import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CertificationsPermitsComponent } from './certifications-permits.component';

// Shared by the legacy /drivers module and the dashboard-2025 drivers module,
// which both route the driver page, so the tab is built once.
@NgModule({
  declarations: [CertificationsPermitsComponent],
  imports: [CommonModule, ReactiveFormsModule, MaterialModule, SharedModule],
  exports: [CertificationsPermitsComponent],
})
export class CertificationsPermitsModule {}
